import { useState } from 'react';
import { X, Download } from 'lucide-react';
import { usePrefetchStatus } from '@/hooks/usePrefetchStatus';

export default function PrefetchProgressIndicator({ providerId }) {
  const { status, completed, total, isPrefetching } = usePrefetchStatus(providerId);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !isPrefetching || status !== 'in_progress') {
    return null;
  }

  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 flex items-center gap-3">
      <Download className="w-4 h-4 text-blue-500 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-blue-700">
          Preparing offline data... {completed}/{total} patients
        </p>
        <div className="mt-1 w-full bg-blue-100 rounded-full h-1.5">
          <div
            className="bg-blue-500 h-1.5 rounded-full transition-all duration-300"
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-blue-400 hover:text-blue-600 flex-shrink-0"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
